import React from 'react';
import Topbar from '../components/TopBar/Topbar';
import { Outlet } from 'react-router';
import Sidebar from '../components/SideBar/Sidebar';

const AdminLayout = () => {
  return (
    <div className='main-wrapper'>
      <div className='layout-wrapper'>
        <aside className='sidebar-wrapper'>
          <Sidebar />
        </aside>
        <main className='content-wrapper'>
          <Topbar />
          <div className='contents'>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
